var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16659 6.41634H20.8333V3.66634H4.16659V6.41634ZM20.8333 8.24967V19.2497C20.8333 19.4928 20.7235 19.7259 20.5282 19.8979C20.3328 20.0698 20.0679 20.1663 19.7916 20.1663H5.20825C4.93198 20.1663 4.66703 20.0698 4.47168 19.8979C4.27633 19.7259 4.16659 19.4928 4.16659 19.2497V8.24967H3.12492C2.84865 8.24967 2.5837 8.1531 2.38835 7.98119C2.193 7.80928 2.08325 7.57612 2.08325 7.33301V2.74967C2.08325 2.50656 2.193 2.2734 2.38835 2.10149C2.5837 1.92958 2.84865 1.83301 3.12492 1.83301H21.8749C22.1512 1.83301 22.4161 1.92958 22.6115 2.10149C22.8068 2.2734 22.9166 2.50656 22.9166 2.74967V7.33301C22.9166 7.57612 22.8068 7.80928 22.6115 7.98119C22.4161 8.1531 22.1512 8.24967 21.8749 8.24967H20.8333ZM6.24992 18.333H18.7499V8.24967H6.24992V18.333ZM10.4166 14.6663H14.5833C14.8595 14.6663 15.1245 14.7629 15.3198 14.9348C15.5152 15.1067 15.6249 15.3399 15.6249 15.583C15.6249 15.8261 15.5152 16.0593 15.3198 16.2312C15.1245 16.4031 14.8595 16.4997 14.5833 16.4997H10.4166C10.1403 16.4997 9.87537 16.4031 9.68002 16.2312C9.48467 16.0593 9.37492 15.8261 9.37492 15.583C9.37492 15.3399 9.48467 15.1067 9.68002 14.9348C9.87537 14.7629 10.1403 14.6663 10.4166 14.6663Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.6366a70165025528ab4fc6b3d99df3bf.svg";
export { ForwardRef as ReactComponent };